import './alert.scss';
export default function Alert({isCorrect}){

	return(
		<div className={`question-alert question-alert--${isCorrect ? 'true':'false'}`}>
			{isCorrect?(
				<>
					<CorrectIcon />
					<div className="question-alert-text">Teisingai</div>
				</>
			):(
				<>
					<WrongIcon />
					<div className="question-alert-text">Neteisingai</div>
				</>
			)}
		</div>
	)
}


function CorrectIcon(){
	return(

		<svg width="88" height="85" viewBox="0 0 88 85" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M19.972 69.3333L0.666992 84.5V4.33333C0.666992 3.18406 1.12354 2.08186 1.9362 1.2692C2.74885 0.456546 3.85105 0 5.00033 0H83.0003C84.1496 0 85.2518 0.456546 86.0645 1.2692C86.8771 2.08186 87.3336 3.18406 87.3336 4.33333V65C87.3336 66.1493 86.8771 67.2515 86.0645 68.0641C85.2518 68.8768 84.1496 69.3333 83.0003 69.3333H19.972ZM16.9733 60.6667H78.667V8.66667H9.33366V66.6683L16.9733 60.6667ZM40.9367 39.5243L59.323 21.1423L65.4503 27.2697L40.9367 51.7833L24.08 34.9267L30.2117 28.7993L40.9367 39.5243Z" fill="currentColor" />
		</svg>

	)
}
function WrongIcon(){
	return(


		<svg width="88" height="85" viewBox="0 0 88 85" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M19.972 69.3333L0.666992 84.5V4.33333C0.666992 3.18406 1.12354 2.08186 1.9362 1.2692C2.74885 0.456546 3.85105 0 5.00033 0H83.0003C84.1496 0 85.2518 0.456546 86.0645 1.2692C86.8771 2.08186 87.3336 3.18406 87.3336 4.33333V65C87.3336 66.1493 86.8771 67.2515 86.0645 68.0641C85.2518 68.8768 84.1496 69.3333 83.0003 69.3333H19.972ZM9.33366 66.6683L16.9733 60.6667H78.667V8.66667H9.33366V66.6683ZM50.1277 34.6667L60.8527 45.3917L54.7253 51.519L44.0003 40.794L33.2753 51.5233L27.148 45.396L37.873 34.6667L27.1437 23.9417L33.271 17.8143L44.0003 28.5393L54.7253 17.8143L60.8527 23.9417L50.1277 34.6667Z" fill="currentColor" />
		</svg>


	)
}